//import config from 'config';
import {
    handleResponse,
    requestOptions
} from '@/_helpers';


export const buildingService = {
    getAll,
    getBuildingsOfUser,
    getBuildingsOfComplex,
    getById,
    getExpenseById,
    addBuilding,
    updateBuilding,
    deleteBuilding,
};

function getExpenseById(id) {
    return fetch('/api/buildings/expenses?id=' + id, requestOptions.get())
        .then(handleResponse);
}

function getById(id) {
    return fetch('/api/buildings/' + id, requestOptions.get())
        .then(handleResponse);
}

/*function getAll() {
    return fetch('/api/buildings', requestOptions.get())
        .then(handleResponse);
}

function getBuildingsOfUser(userId) {
    return fetch('/api/buildings/user?id=' + userId, requestOptions.get())
        .then(handleResponse);
}*/

function getAll() {
    return fetch('/api/buildings/realestate', requestOptions.get())
        .then(handleResponse);
}

function getBuildingsOfUser(userId) {
    return fetch('/api/buildings/realestate/user?id=' + userId, requestOptions.get())
        .then(handleResponse);
}

function getBuildingsOfComplex(complexId) {
    return fetch('/api/buildings/complex?complexId=' + complexId, requestOptions.get())
        .then(handleResponse);
}

function addBuilding(name, streetName, number, city, postCode, userId, isComplex, openingBalance, complexId, useMonthlyExpenses, registrationYear) {
    return fetch('/api/buildings', requestOptions.post({
            name,
            streetName,
            number,
            city,
            postCode,
            userId,
            isComplex,
        openingBalance,
        complexId,
        useMonthlyExpenses,
        registrationYear
        }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}

function updateBuilding(id, name, streetName, number, city, postCode, isComplex, openingBalance, complexId, useMonthlyExpenses, registrationYear) {
    return fetch('/api/buildings/' + id, requestOptions.put({
            id,
            name,
            streetName,
            number,
            city,
            postCode,
            isComplex,
        openingBalance,
        complexId,
        useMonthlyExpenses,
        registrationYear
        }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}

function deleteBuilding(id) {
    console.log("Buidling id: " +id)
    return fetch('/api/buildings/' + id, requestOptions.delete({
            id
        }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}